import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl } from "@mui/material";
import { getOrigin } from "../../../http/api/MasterAPI";

const OriginSelect = ({ onChange, value }) => {
  const [listOrigin, setListOrigin] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || null);

  async function getListOrigin() {
    try {
      const response = await getOrigin();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          originId: element.varCd,
          originName: element.varValue1,
        }))
        .filter(
          (x) => x.originName && x.originName.trim() !== ""
        );
      setListOrigin(result);
    } catch (error) {
      console.error("担当者を取得するとき不具合発生した。", error);
    }
  }

  useEffect(() => {
    getListOrigin();
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <Select
        value={selectedValue}
        onChange={handleSelectionChange}
        sx={{ width: 400 }}
      >
        <MenuItem key="unselected" value={null}>
          [未選択]
        </MenuItem>
        {listOrigin.map((item) => (
          <MenuItem
            key={item.originId}
            value={item.originId}
          >
            {item.originName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default OriginSelect;
